import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';
import NotifyMailroomSwitch from 'src/components/NotifyMailroomSwitch';

import { ActionComponentProps } from '../../index';
import { CollapsibleOptions } from './CollapsibleOptions';

export const MarkPickedUp = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();
  const [notifyMailroom, setNotifyMailroom] = useState<boolean>(false);

  const confirmAction = async () => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.FinishPickupMailbox,
      isForce,
      ...(isForce && { shouldNotifyMailroom: notifyMailroom }),
    }).unwrap();

    onActionFinish();
  };

  const content = (
    <>
      {mailpieces.length === 1 ? (
        <Typography variant="body1" color="text.secondary">
          Are you sure you would like to mark this item as picked up?
        </Typography>
      ) : (
        <Typography variant="body1" color="text.secondary">
          Are you sure you would like to mark this <strong>{mailpieces.length}</strong> items as picked up?
        </Typography>
      )}
      <CollapsibleOptions>
        <Box sx={{ pt: 1 }}>
          <NotifyMailroomSwitch
            checked={notifyMailroom}
            onChange={() => setNotifyMailroom(!notifyMailroom)}
            label="Notify mailroom users about pending request"
          />
        </Box>
      </CollapsibleOptions>
    </>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Mark item as picked up' : 'Mark selected items as picked up'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Mark as Picked Up"
      cancelButtonTitle="Cancel"
    />
  );
};
